export function encodeStatementRowUrn(row: FlatStatementRow): string
{
    return `row:${row.id}`;
}
